import { createSelector } from '@reduxjs/toolkit';
import { SmoMoonType } from '../../../../Models/Smo/SmoMoonType';
import { storeSelector } from '../StoreSelector';

const isDebugMode = createSelector(storeSelector, (state) => state.debug.debugMode);
const isImageProcessingPaused = createSelector(storeSelector, (state) => state.debug.isImageProcessingPaused);

const singleMoonFilterBrightness = createSelector(
  storeSelector,
  (state) => state.videoAnalysis.filterBrightness[SmoMoonType.single].value
);
const multiMoonFilterBrightness = createSelector(
  storeSelector,
  (state) => state.videoAnalysis.filterBrightness[SmoMoonType.multi].value
);
const singleMoonComparisonMisMatchPercent = createSelector(
  storeSelector,
  (state) => state.videoAnalysis.filterBrightness[SmoMoonType.single].comparisonMisMatchPercent
);

const singleMoonCroppedTitles = createSelector(storeSelector, (state) => state.debug.moonImages.single.croppedTitles);
const singleMoonCroppedFilteredTitles = createSelector(
  storeSelector,
  (state) => state.debug.moonImages.single.croppedFilteredTitles
);
const singleMoonCroppedNames = createSelector(storeSelector, (state) => state.debug.moonImages.single.croppedNames);
const singleMoonCroppedFilteredNames = createSelector(
  storeSelector,
  (state) => state.debug.moonImages.single.croppedFilteredNames
);
const multiMoonCroppedNames = createSelector(storeSelector, (state) => state.debug.moonImages.multi.croppedNames);
const multiMoonCroppedFilteredNames = createSelector(
  storeSelector,
  (state) => state.debug.moonImages.multi.croppedFilteredNames
);

export default {
  isDebugMode,
  isImageProcessingPaused,
  singleMoonFilterBrightness,
  multiMoonFilterBrightness,
  singleMoonComparisonMisMatchPercent,
  singleMoonCroppedTitles,
  singleMoonCroppedFilteredTitles,
  singleMoonCroppedNames,
  singleMoonCroppedFilteredNames,
  multiMoonCroppedNames,
  multiMoonCroppedFilteredNames
};
